<nav id="navbar-main" class="navbar navbar-main navbar-expand-lg navbar-transparent navbar-light headroom headroom--top headroom--pinned">
  <div class="container">
    <a class="navbar-brand mr-lg-5" href="https://www.sourcecode.tw/SourceCode">
      <img src="./assets/img/brand/white.png">
    </a>
    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed"
          [attr.aria-expanded]="!isCollapsed" aria-controls="navbar_global">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="navbar-collapse collapse" id="navbar_global" [ngbCollapse]="isCollapsed" style="padding-left: 60%;">
      <div class="navbar-collapse-header">
        
      </div>
      <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto" style="float:right;">
        <li class="nav-item dropdown">
          <a class="nav-link no-caret" data-toggle="dropdown" role="button">
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text"><h4 style="color: aliceblue;">資訊安全</h4></span>
          </a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link no-caret" data-toggle="dropdown" role="button">
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text"><h4 style="color: aliceblue;">技術開發</h4></span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
